
import React from 'react';
import Layout from '@/components/Layout';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <Helmet>
        <title>Privacy Policy - Calculator | Terms, Conditions & Disclaimer</title>
        <meta name="description" content="Read our privacy policy and disclaimer. Learn about how we protect your data and important information about calculator usage responsibility." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="/privacy-policy" />
      </Helmet>

      <div className="container mx-auto px-6 py-12 max-w-4xl animate-fade-in">
        <h1 className="text-4xl font-bold mb-8 text-center">Privacy Policy & Disclaimer</h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none space-y-6">
          <section className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-lg mb-8">
            <h2 className="text-2xl font-semibold mb-4">Disclaimer on Calculator Usage</h2>
            <p className="mb-4">
              The calculators provided on this website are designed for educational and entertainment purposes. While we strive for accuracy, please note:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>All calculations are estimates and should not be considered as professional financial, medical, or legal advice.</li>
              <li>Users are solely responsible for verifying results and consulting with qualified professionals for important decisions.</li>
              <li>Results may vary based on numerous factors not accounted for in these basic calculations.</li>
              <li>We make no guarantees regarding the accuracy, completeness, or reliability of calculations.</li>
            </ul>
          </section>

          <section className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-lg mb-8">
            <h2 className="text-2xl font-semibold mb-4">Information Collection and Usage</h2>
            <p className="mb-4">
              We value your privacy and are committed to protecting your personal information. Here's how we handle data:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>We collect minimal personal information, limited to what's necessary for calculator functionality.</li>
              <li>Calculator inputs are processed locally in your browser when possible.</li>
              <li>We use cookies and similar technologies for essential website functionality.</li>
              <li>We do not sell or share your personal information with third parties.</li>
            </ul>
          </section>

          <section className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-lg mb-8">
            <h2 className="text-2xl font-semibold mb-4">Calculator Request Feature</h2>
            <p className="mb-4">
              When you submit a calculator request:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>We collect your email address solely to respond to your request.</li>
              <li>Your request details are stored securely and used only for development purposes.</li>
              <li>You can request deletion of your submitted information at any time.</li>
            </ul>
          </section>

          <section className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-lg mb-8">
            <h2 className="text-2xl font-semibold mb-4">Important Notices</h2>
            <div className="space-y-4">
              <p>
                <strong>Financial Calculators:</strong> Results are approximations and should not replace professional financial advice. Market conditions, taxes, and other factors may significantly impact actual outcomes.
              </p>
              <p>
                <strong>Health Calculators:</strong> These tools provide general estimates and should not substitute for professional medical advice, diagnosis, or treatment. Always consult healthcare professionals for medical decisions.
              </p>
              <p>
                <strong>Educational Calculators:</strong> These tools are learning aids and should be used in conjunction with proper educational resources and guidance.
              </p>
              <p>
                <strong>Professional Calculators:</strong> Business and professional calculators are for preliminary estimations only. Consult with relevant experts for important business decisions.
              </p>
            </div>
          </section>

          <section className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-lg">
            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p>
              If you have questions about this privacy policy or our calculators, please use our calculator request form to reach out to us.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
